import React from "react";
import type { TraceComment } from "../types";

interface TraceCommentsProps {
  comments: TraceComment[];
}

export function TraceComments({ comments }: TraceCommentsProps) {
  if (comments.length === 0) return null;

  const sorted = [...comments].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );

  return (
    <div>
      <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3">
        Comments
      </h3>
      <div className="space-y-2">
        {sorted.map((c) => (
          <div
            key={c.id}
            className="border border-border rounded-lg p-3 bg-card space-y-1"
          >
            <p className="text-sm text-foreground">{c.comment}</p>
            <p className="text-xs text-muted-foreground">
              {new Date(c.created_at).toLocaleString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
